<template>
  <client-only>
    <section :class="bindContentClass" v-show="isRender">
      <!-- 欧洲一些国家符号放在后面 -->
      <template v-if="symbolInAfter">
        <div class="symbol" v-show="prefix" :style="{ color: injectColor }">
          {{ prefix }}
        </div>
        <div
          class="sprice"
          :id="isBeat ? 'spriceRef' : ''"
          :style="{ color: injectColor }"
        >
          <template>
            {{ price | formatMoney }}
          </template>
        </div>
        <div class="sprefix">
          <span
            class="currency"
            v-show="!isRenderKwalletIocn"
            :style="{ color: injectColor }"
            >{{ currency }}</span
          >
          <img
            v-show="isRenderKwalletIocn"
            class="k-coin"
            alt="k-coin"
            v-lazy="require('@/assets/images/wallet/T-coin.png')"
          />
        </div>
      </template>
      <template v-else>
        <div class="symbol" v-show="prefix" :style="{ color: injectColor }">
          {{ prefix }}
        </div>
        <div class="sprefix">
          <img
            v-show="isRenderKwalletIocn"
            class="k-coin"
            alt="k-coin"
            v-lazy="require('@/assets/images/wallet/T-coin.png')"
          />

          <span
            class="currency"
            v-show="!isRenderKwalletIocn"
            :style="{ color: injectColor }"
            >{{ currency }}</span
          >
        </div>
        <div
          class="sprice bm-sprice"
          :id="isBeat ? 'spriceRef' : ''"
          :style="{ color: injectColor }"
        >
          {{ price | formatMoney }}
        </div>
      </template>
    </section>
  </client-only>
</template>
<script>
  import isEmpty from 'lodash/isEmpty'
  import { mapState, mapGetters } from 'vuex'
  import { TopLupe_WalletName } from '@/pages/Detail/config'
  import { moneyFormatRules } from '@/utils/moneyFormatRules'
  import { CountUp } from 'countup.js'
  export default {
    props: {
      className: {
        type: String,
        default: '',
      },
      // 展示的价格
      price: {
        type: Number,
        default: 0,
        required: true,
      },
      // 价格前缀
      prefix: {
        type: String,
        default: '',
      },
      isRender: {
        type: Boolean,
        default: true,
      },
      // 是否展示动效[目前只有实际支付价格展示特效]
      isBeat: {
        type: Boolean,
        default: false,
      },
      // 是否展示 wallet 的icon
      isRenderKB: {
        type: Boolean,
        default: false,
      },
      // 直接改变颜色【CP模板化】
      injectColor: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        isKwalletSelected: false, // 选中是否为钱包的支付方式
      }
    },
    computed: {
      ...mapState(['currency']),
      ...mapState('detail', ['selectChannelItem']),
      ...mapGetters(['isRuPubgm']),
      bindContentClass() {
        const clasList = ['price-content', this.className]
        this.symbolInAfter && clasList.push('price-content-after')
        return clasList
      },

      symbolInAfter() {
        return moneyFormatRules.SymbolInAfter
      },
      //   优惠券 || 折扣不会展示
      isRenderKwalletIocn() {
        return this.isKwalletSelected && this.isRenderKB
      },
      watchPrice() {
        return this.price
      },
    },
    watch: {
      selectChannelItem: {
        handler(newVal) {
          if (isEmpty(newVal)) return
          this.isKwalletSelected = newVal.payMethodName === TopLupe_WalletName
        },
        deep: true,
        immediate: true,
      },
      watchPrice: {
        handler(newPrice, oldPrice) {
          this.realPayPriceHandle(newPrice, oldPrice)
        },
      },
    },
    methods: {
      // warn 先写逻辑、后期写动效
      realPayPriceHandle(newPrice, oldPrice) {
        // 渠道优惠的价格
        // https://github.com/inorganik/countUp.js

        if (!this.isBeat) return

        this.$nextTick(() => {
          // 俄罗斯货币符号放在数字后
          const { decimalPlaces, decimal, separator } = moneyFormatRules

          const countUp = new CountUp('spriceRef', newPrice, {
            startVal: oldPrice,
            decimalPlaces: decimalPlaces,
            duration: 1,
            decimal: decimal,
            separator: separator,
          })
          countUp.start()
        })
      },
    },
  }
</script>
<style lang="scss" scoped src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
